import { pushDataLayerEvent } from '@/modules/services/gtm'
import { authenticationSteps } from '@/modules/config/authentication'
import { mapState } from 'vuex'

const authPopupMixins = {
  data () {
    return {
      alreadyTracked: false // To Avoid Duplicate Tracking
    }
  },

  computed: {
    ...mapState({
      authStep: state => state.authentication.authStep
    })
  },

  methods: {
    trackCloseAuthenticationModal () {
      pushDataLayerEvent(
        'click_close_authentication_modal_x',
        {
          params: {
            click_value: this.clickValue()
          }
        }
      )
    },

    clickValue () {
      switch (this.authStep) {
        case authenticationSteps.VALIDATE:
          return 'Start sign in/up'
        case authenticationSteps.REGISTER_NEW:
          return 'Register'
        case authenticationSteps.REGISTRATION_FORM:
        case authenticationSteps.REGISTER_SOCIAL:
          return 'Create an account'
        case authenticationSteps.VERIFICATION_EMAIL_SENT:
          return 'Verify your account'
        default:
          return null
      }
    },

    resetAlreadyTracked () {
      this.alreadyTracked = false
    }
  }
}

export {
  authPopupMixins
}
